import { render } from "./TimelineHeader.vue?vue&type=template&id=28e0d73b&scoped=true"
const script = {}

import "./TimelineHeader.vue?vue&type=style&index=0&id=28e0d73b&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e0d73b"]])

export default __exports__